"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCoreRow = void 0;
const react_1 = require("react");
exports.GridCoreRow = (0, react_1.memo)(function GridCoreRow({ data, index, style }) {
    return data.renderer({
        index,
        style,
        width: data.rowWidth
    });
});
//# sourceMappingURL=GridCoreRow.js.map